import React from 'react';
import PropTypes from 'prop-types';
import Picture from '@deporvillage/picture-component';

import styles from './Klarna.module.scss';

const Klarna = ({ text_main, text_legal, actions, image, impression_url }) => {

    React.useEffect(() => {
        /* eslint-disable-next-line no-undef */
        if (impression_url) fetch(impression_url, { mode: 'no-cors' });
    }, [impression_url]);

    return (
        <div className={ styles['klarna-component'] }>

            { image ? <div className={ styles['image'] }>
                 <Picture src={ image.url } alt={ image.alt } height={ 30 } lazy/>
            </div> : null }

            <div className={ `${ styles['message'] } ${ text_legal || actions && actions.prequalify ? `` : styles['single-line-message'] }` }>
                <div className={ styles['main'] }>

                    { text_main ? text_main : null }

                    { actions && actions.learn_more ? (
                            <a
                                rel={ 'noopener noreferrer' }
                                target={ '_blank' }
                                title={ actions.learn_more.label }
                                href={ actions.learn_more.url}
                            >
                                { actions.learn_more.label }
                            </a>
                        ) : null
                    }

                    { actions && actions.prequalify ? (
                            <a
                                rel={ 'noopener noreferrer' }
                                target={ '_blank' }
                                title={ actions.prequalify.label }
                                href={ actions.prequalify.url}
                            >
                                { actions.prequalify.label }
                            </a>
                        ) : null
                    }

                </div>

                { text_legal ? (
                        <div className={ styles['secondary'] }>
                            { text_legal }
                        </div>
                    ) : null
                }

            </div>
        </div>
    );
};

Klarna.propTypes = {
    text_main: PropTypes.string,
    text_legal: PropTypes.string,
    actions: PropTypes.shape({
        learn_more: PropTypes.shape({
            label: PropTypes.string,
            url: PropTypes.string,
        }),
        prequalify: PropTypes.shape({
            label: PropTypes.string,
            url: PropTypes.string,
        }),
    }),
    image: PropTypes.shape({
        alt: PropTypes.string,
        url: PropTypes.string,
    }),
    impression_url: PropTypes.string,

};

export default Klarna;
